import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("caves.christophe@wanadoo.fr");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin", { replace: true });
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#110F0F] flex items-center justify-center px-5">
      <div data-testid="admin-login-modal" className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="mx-auto inline-flex" data-testid="admin-login-logo">
            <img
              src="/logo-caves-christophe.png"
              alt="Caves Christophe · Christophe Guédon"
              className="h-12 w-auto brightness-0 invert"
            />
          </div>
          <h1 className="font-serif text-3xl font-bold text-[#FDFBF7] mt-4">Espace Caviste</h1>
          <p className="text-[#F5EFEB]/60 text-sm mt-1">BOX VIN · Cave Christophe</p>
        </div>
        <form onSubmit={submit} className="bg-[#1A1818] rounded-2xl p-6 space-y-4 border border-white/10">
          <div className="space-y-1.5">
            <Label className="text-[#F5EFEB]">Email</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)}
              type="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} inputMode="email"
              autoComplete="username"
              className="bg-[#110F0F] border-white/10 text-[#FDFBF7]" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[#F5EFEB]">Mot de passe</Label>
            <Input data-testid="input-admin-password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
              className="bg-[#110F0F] border-white/10 text-[#FDFBF7]" required />
          </div>
          {error && <p data-testid="login-error" className="text-red-400 text-sm">{error}</p>}
          <Button data-testid="btn-admin-login-submit" type="submit" disabled={loading}
            className="w-full bg-[#581825] hover:bg-[#42101A] text-[#FDFBF7] h-11">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Se connecter"}
          </Button>
        </form>
        <button onClick={() => navigate("/")} className="w-full text-center text-[#F5EFEB]/50 text-sm mt-6 hover:text-[#C5A059]">
          ← Retour au site public
        </button>
      </div>
    </div>
  );
}
